export interface GetReserveConfirmRequest {
  id: number
  collectionNo: string
}

export function GetReserveConfirmRequestToJSON(
  value: GetReserveConfirmRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined
  }
}
